import React from 'react';
import { set } from 'dot-prop-immutable';
import { toolFormAttr, toolCollapseAttr, getLocale } from '@utils/util';
import { SimpleForm as Form, Collapse, Switch, Input } from '@whalecloud/fdx';
import CustomInput from '@whalecloud/page-builder-base-components/components/CustomInput';
import CommonItemSettings from '@whalecloud/page-builder-base-components/components/ElementSettings/CommonItemSettings';

const { Panel } = Collapse;

const valueKey = 'data.formItemSettings';

const SwitchSettings = (props: any) => {
  const messages = getLocale();

  const { updateElement, element } = props;
  const { data: { formItemSettings = {} } = {} } = element;

  const {
    defaultChecked = true,
    checkedChildren,
    unCheckedChildren,
  } = formItemSettings;

  const initialValues = {
    defaultChecked,
    checkedChildren,
    unCheckedChildren,
  };

  const onFormChange = (obj: Object) => {
    Object.keys(obj).forEach((key: string) => {
      const propName = `${valueKey}.${key}`;
      const newElement = set(element, propName, obj[key]);

      updateElement({
        element: newElement,
      });
    });
  };
  return (
    <Collapse {...toolCollapseAttr} defaultActiveKey={['1']}>
      <Panel header={messages.PAGEBUIDER_SETTINGS} key="1">
        <CommonItemSettings allowClearHide placeholderHide defaultValueHide />
        <Form {...toolFormAttr} initialValues={initialValues} onValuesChange={onFormChange}>
          <Form.Item label={messages.PAGEBUIDER_SETTINGS_SWITCH_DEFAULT_CHECKED} name="defaultChecked" valuePropName="checked">
            <Switch />
          </Form.Item>
          <Form.Item label={messages.PAGEBUIDER_SETTINGS_SWITCH_CHECKED_CHILD} name="checkedChildren">
            <CustomInput />
          </Form.Item>
          <Form.Item label={messages.PAGEBUIDER_SETTINGS_SWITCH_UNCHECKED_CHILD} name="unCheckedChildren">
            <CustomInput />
          </Form.Item>
        </Form>
      </Panel>
    </Collapse>
  );
};

export default SwitchSettings;
